"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PlayBackProps = void 0;

var _vue = require("vue");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/createForOfIteratorHelper"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _alert = _interopRequireDefault(require("ant-design-vue/lib/alert"));

require("ant-design-vue/lib/alert/style/index.css");

var _utils = require("../utils");

var _useRenderSheet2 = _interopRequireDefault(require("../hooks/useRenderSheet"));

var _playBar = _interopRequireDefault(require("./playBar"));

var _playScoreShow = _interopRequireDefault(require("./playScoreShow"));

var _types = require("./types");

var _types2 = require("../types");

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var PlayBackProps = {
  changePlayScoreLoading: Function,
  sheetProps: Object,
  replayPlayParams: Object,
  recordResultAudio: Blob,
  recordReplayJson: String,
  recordScoreResultRealTime: Array,
  recordReplayVisible: Boolean,
  eurFileUrl: String,
  playMode: {
    type: String,
    default: 'ori'
  }
};
exports.PlayBackProps = PlayBackProps;
var Playback = (0, _vue.defineComponent)({
  name: 'Playback',
  components: {
    PlayBar: _playBar.default,
    PlayScoreShow: _playScoreShow.default
  },
  props: PlayBackProps,
  emit: ['update:recordReplayVisible'],
  setup: function setup(props, ctx) {
    var _this = this;

    var _useRenderSheet = (0, _useRenderSheet2.default)(props.sheetProps),
        sheetMusicEl = _useRenderSheet.sheetMusicEl,
        loadSheetResult = _useRenderSheet.loadSheetResult,
        sheetMusicBusiness = _useRenderSheet.sheetMusicBusiness,
        setBusinessOptions = _useRenderSheet.setBusinessOptions,
        renderSheet = _useRenderSheet.renderSheet,
        destroySheet = _useRenderSheet.destroySheet;

    var sheetMusicContainer = (0, _vue.ref)(); // 音乐控制条相关参数

    var playBarOptions = (0, _vue.reactive)({
      seconds: undefined,
      curentSeconds: 0,
      drag: false,
      isFinish: false
    });
    var startTime = (0, _vue.ref)(0);
    var currentTime = (0, _vue.ref)(0);
    var duration = (0, _vue.ref)(0);
    var currScore = (0, _vue.ref)(0);
    var playState = (0, _vue.ref)(_types2.PlayState.stop);
    var dragStartTime = (0, _vue.ref)(undefined);
    var isShowTips = (0, _vue.ref)(false);
    var playMode = (0, _vue.ref)(props.playMode);
    var alertTips = (0, _vue.reactive)({
      show: false,
      showIcon: true,
      type: 'warning',
      message: '',
      showMessage: function showMessage(type, message) {
        var showIcon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        this.show = true;
        this.type = type;
        this.message = message;
        this.showIcon = showIcon;
      },
      hideMessage: function hideMessage() {
        this.show = false;
      }
    });
    var isCanPlay = (0, _vue.computed)(function () {
      var _a;

      return !!((_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.viewer);
    });
    var recordResultAudioUrl = (0, _vue.computed)(function () {
      if (props.recordResultAudio) {
        return window.URL.createObjectURL(props.recordResultAudio);
      }

      return '';
    });
    var errorJsonUrl = (0, _vue.computed)(function () {
      if (props.recordReplayJson) {
        return window.URL.createObjectURL(new Blob([props.recordReplayJson], {}));
      }

      return '';
    });
    var eurUrl = (0, _vue.computed)(function () {
      if (props.eurFileUrl) {
        var isUrl = /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/.test(props.eurFileUrl);
        return isUrl ? props.eurFileUrl : window.URL.createObjectURL(new Blob([props.eurFileUrl], {}));
      }

      return '';
    });
    var playParams = (0, _vue.computed)(function () {
      console.log('回放音频', recordResultAudioUrl.value);
      console.log('回放参数', props.replayPlayParams);
      return (0, _extends2.default)((0, _extends2.default)({}, props.replayPlayParams), {
        url: recordResultAudioUrl.value
      });
    });
    /** 处理播放插件 */

    var pluginOptions = function pluginOptions() {
      return {
        ErrorCorrectionRenderPlugin: {
          enable: true,
          init: function init(plugin) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      plugin.install();

                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));
          }
        }
      };
    }; // 处理播放工具相关参数


    var initPlayerTool = function initPlayerTool() {
      return new Promise(function (resolve, reject) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          var _a, _b, _c, playerToolType;

          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.initPlayerTool(playEvents.value);
                  playerToolType = ((_b = playParams.value.range) === null || _b === void 0 ? void 0 : _b[1]) ? _utils.PlayerToolType.RePlay_Mp3_AB : _utils.PlayerToolType.RePlay_Mp3;
                  _context2.next = 5;
                  return (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.changePlayerTool(playerToolType);

                case 5:
                  resolve();
                  _context2.next = 11;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](0);
                  reject(_context2.t0);

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 8]]);
        }));
      });
    };

    var playEvents = (0, _vue.ref)({
      ON_START: function ON_START(_ref) {
        var _startTime = _ref.startTime,
            _preReadyTime = _ref.preReadyTime,
            seekTo = _ref.seekTo;
        console.log('replay ON_START', _startTime, _preReadyTime, seekTo);
        startTime.value = seekTo / 1000;
      },
      ON_STOP: function ON_STOP(playerTool) {
        playState.value = _types2.PlayState.stop;
        resetPlayTime();
        playerTool.plugin.$highlight.disable();
        playerTool.plugin.$errorCorrectionRender.enable();
      },
      ON_TIME_UPDATE: function ON_TIME_UPDATE() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$time = _ref2.time,
            time = _ref2$time === void 0 ? 0 : _ref2$time,
            _ref2$duration = _ref2.duration,
            _duration = _ref2$duration === void 0 ? Infinity : _ref2$duration;

        var _a; // 音高条tick


        var tickTime = Math.floor(playParams.value.recordStartTime + time); // console.log('replay ON_TIME_UPDATE', tickTime);

        (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$pitchBarRender.pitchBarTick(tickTime);
        currentTime.value = time / 1000;
        duration.value = _duration / 1000;
      }
    });

    var onPlayStateChange = function onPlayStateChange(platState) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _a, _b, _c, playerTool;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                playerTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool;
                _context3.t0 = platState;
                _context3.next = _context3.t0 === 'start' ? 4 : _context3.t0 === 'pause' ? 8 : _context3.t0 === 'continue' ? 10 : _context3.t0 === 'stop' ? 12 : 15;
                break;

              case 4:
                (_c = (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$errorCorrectionRender) === null || _c === void 0 ? void 0 : _c.clearAllMarkImage();
                playerTool.plugin.$highlight.enable();
                playerTool.prepare(playParams.value).then(function () {
                  playerTool.start(playParams.value.range);
                });
                return _context3.abrupt("break", 16);

              case 8:
                playerTool.pause();
                return _context3.abrupt("break", 16);

              case 10:
                playerTool.continue();
                return _context3.abrupt("break", 16);

              case 12:
                playerTool.stop();
                resetPlayTime();
                return _context3.abrupt("break", 16);

              case 15:
                return _context3.abrupt("break", 16);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    };
    /**
     * 停止播放后，滚动到顶部，清除纠错图标
     * @param playState
     */


    var onStopScroll = function onStopScroll(playState) {
      var _a, _b;

      if (playState === _types2.PlayState.stop) {
        (_b = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$highlight) === null || _b === void 0 ? void 0 : _b.scrollToTop(false);
      }
    };

    var resetPlayTime = function resetPlayTime() {
      currentTime.value = 0;
      duration.value = 0;
      currScore.value = 0;
    };

    var loadErrorJson = function loadErrorJson() {
      return new Promise(function (resolve, reject) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
          var _a, _b, _c, _d, _e, _f, _g, playerTool, part, timeParams;

          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  playerTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool; // await playerTool.plugin.$errorCorrectionRender.load(errorJsonUrl.value);
                  // playerTool.plugin.$errorCorrectionRender.enable();

                  _context4.next = 4;
                  return playerTool.plugin.$pitchBarRender.loadEur(eurUrl.value);

                case 4:
                  (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$pitchBarRender.enable(); // 加载eur,展示音高条

                  part = 'P' + playParams.value.scorePart;
                  console.log('声部', part);
                  timeParams = (0, _extends2.default)((0, _extends2.default)({}, _types.recorderTimeParamsMap[playMode.value]), {
                    isNeedLude: playParams.value.scoreType === 0 ? false : true,
                    playBackSpeed: playParams.value.speed
                  });
                  (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$pitchBarRender.getPitchNotes(part, timeParams, {
                    isGrace: true,
                    isChord: true,
                    isStaccato: true,
                    isMordent: true,
                    isTrill: true,
                    isTieMerge: false,
                    isRapNeedPitch: true
                  });
                  _context4.next = 11;
                  return (_d = sheetMusicBusiness.value) === null || _d === void 0 ? void 0 : _d.setDisplayMode(playParams.value.displayMode);

                case 11:
                  _context4.next = 13;
                  return (_e = sheetMusicBusiness.value) === null || _e === void 0 ? void 0 : _e.refreshSheet();

                case 13:
                  (_f = sheetMusicBusiness.value) === null || _f === void 0 ? void 0 : _f.plugin.$closeAreaSelection.disable();
                  (_g = sheetMusicBusiness.value) === null || _g === void 0 ? void 0 : _g.plugin.$openAreaSelection.disable();
                  resolve('');
                  _context4.next = 21;
                  break;

                case 18:
                  _context4.prev = 18;
                  _context4.t0 = _context4["catch"](0);
                  reject(_context4.t0);

                case 21:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 18]]);
        }));
      });
    }; // 检查是否有曲谱url


    var checkSheetFileUrl = function checkSheetFileUrl() {
      return new Promise(function (resolve, reject) {
        var _a, _b;

        if (!((_b = (_a = props.sheetProps) === null || _a === void 0 ? void 0 : _a.song) === null || _b === void 0 ? void 0 : _b.evxmlFileUrl)) {
          loadSheetResult.value = false;
          console.warn('没有曲谱文件');
          reject(new Error('没有曲谱文件'));
        }

        resolve();
      });
    }; // 退出回放


    var closePlayBack = function closePlayBack() {
      ctx.emit('update:recordReplayVisible', false);
    };

    (0, _vue.watch)(function () {
      return dragStartTime.value;
    }, function (newVal) {
      var _a;

      if (newVal !== undefined) {
        var playerTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool;
        playerTool && playerTool.dragStart(newVal * 1000);
      }
    });
    (0, _vue.watchEffect)(function () {
      playBarOptions.curentSeconds = (currentTime.value || 0) / 1000;
      playBarOptions.seconds = (duration.value || 0) / 1000;

      if (currentTime.value === duration.value) {
        playBarOptions.isFinish = true;
      } else {
        playBarOptions.isFinish = false;
      }
    });
    (0, _vue.watch)(function () {
      return playState.value;
    }, function (newVal) {
      onPlayStateChange(newVal);
      onStopScroll(newVal);

      if (newVal === 'start' || newVal === 'pause' || newVal === 'continue') {
        playBarOptions.drag = true;
      } else {
        playBarOptions.drag = false;
      }
    });
    (0, _vue.watch)(function () {
      return currentTime.value;
    }, function (newVal) {
      if (newVal > 0) {
        var _iterator = (0, _createForOfIteratorHelper2.default)(props.recordScoreResultRealTime),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var replayScore = _step.value;
            var tickTime = newVal + startTime.value;

            if (replayScore.start <= tickTime && tickTime <= replayScore.end) {
              currScore.value = replayScore.score;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    });
    (0, _vue.watch)(function () {
      return isShowTips.value;
    }, function (newVal) {
      if (newVal) {
        if (playState.value !== _types2.PlayState.start && playState.value !== _types2.PlayState.pause && playState.value !== _types2.PlayState.continue) {
          alertTips.showMessage('info', '停止状态不可拖动进度条');
          setTimeout(function () {
            alertTips.hideMessage();
          }, 700);
        }

        isShowTips.value = false;
      }
    });
    (0, _vue.onMounted)(function () {
      props.changePlayScoreLoading(true);
      checkSheetFileUrl().then(function () {
        return setBusinessOptions({
          pluginOptions: pluginOptions()
        });
      }).then(renderSheet).then(initPlayerTool).then(loadErrorJson).then(function () {
        props.changePlayScoreLoading(false);
      });
    });
    (0, _vue.onBeforeUnmount)(function () {
      window.URL.revokeObjectURL(recordResultAudioUrl.value);
      window.URL.revokeObjectURL(errorJsonUrl.value);
      destroySheet();
    });
    return {
      sheetMusicContainer: sheetMusicContainer,
      sheetMusicEl: sheetMusicEl,
      duration: duration,
      playState: playState,
      currentTime: currentTime,
      isCanPlay: isCanPlay,
      isShowTips: isShowTips,
      alertTips: alertTips,
      closePlayBack: closePlayBack,
      playBarOptions: playBarOptions,
      currScore: currScore,
      dragStartTime: dragStartTime
    };
  },
  render: function render() {
    var _this2 = this;

    return (0, _vue.createVNode)("div", {
      "class": "sheet-music-song-playback"
    }, [(0, _vue.createVNode)("div", {
      "class": "all-score"
    }, [(0, _vue.createVNode)(_playScoreShow.default, {
      "score": true,
      "totalScore": this.currScore
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "sheet-music-container",
      "ref": "sheetMusicContainer"
    }, [(0, _vue.createVNode)("div", {
      "id": "paper",
      "ref": "sheetMusicEl"
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "player-control-board-contianer"
    }, [(0, _vue.createVNode)(_playBar.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({
      "class": "playback-playbar"
    }, this.playBarOptions), {}, {
      "curentSeconds": this.currentTime,
      "seconds": this.duration,
      "state": _this2.playState,
      "onUpdate:state": function onUpdateState($event) {
        return _this2.playState = $event;
      },
      "dragStartTime": _this2.dragStartTime,
      "onUpdate:dragStartTime": function onUpdateDragStartTime($event) {
        return _this2.dragStartTime = $event;
      },
      "isShowTips": _this2.isShowTips,
      "onUpdate:isShowTips": function onUpdateIsShowTips($event) {
        return _this2.isShowTips = $event;
      }
    }), null)]), (0, _vue.createVNode)("div", {
      "class": "exit",
      "onClick": function onClick() {
        return _this2.closePlayBack();
      }
    }, null), this.alertTips.show && (0, _vue.createVNode)("div", {
      "class": "alert-tips"
    }, [(0, _vue.createVNode)(_alert.default, (0, _objectSpread2.default)({
      "showIcon": true
    }, this.alertTips), null)])]);
  }
});
var _default = Playback;
exports.default = _default;